import moment from "moment/moment";

export let scrollHandler = {
    data: function () {
        return {
            scrollPosition: 0,

        }
    },
    components: {},
    methods: {
        handleScroll: function () {
            window.requestAnimationFrame(function () {
                this.scrollPosition = window.scrollY;

            }.bind(this))
        },
        focusMessage: function () {
            jQuery('#message').focus()
        }
    },
    destroyed() {
        window.removeEventListener('DOMContentLoaded', this.handleScroll);
    },
    created: function () {
        window.addEventListener('scroll', this.handleScroll, {passive: true});
    },
    watch: {}
}

export let customFunctions = {

    methods: {
        getBackground(t) {
            if (t.better_featured_image.media_details.sizes.medium_large) {
                return "url('" + t.better_featured_image.media_details.sizes.medium_large.source_url + "')";
            }
            else if (t.better_featured_image.media_details.sizes.medium) return "url('" + t.better_featured_image.media_details.sizes.medium.source_url + "')";
            else {
                return "url('" + t.better_featured_image.source_url + "')";
            }
        },
        checkLink(link) {
            return link.match('(?:(?:https?|ftp|file):\/\/|www\.|ftp\.)(?:\([-A-Z0-9+&@#\/%=~_|$?!:,.]*\)|[-A-Z0-9+&@#\/%=~_|$?!:,.])*(?:\([-A-Z0-9+&@#\/%=~_|$?!:,.]*\)|[A-Z0-9+&@#\/%=~_|$])') !== null;
        },
        shortLink: function (link) {
            return link.replace(/^.*\/\/[^\/]+/, '');
        },
        neuerBericht(reps, months) {
            let dates = []
            if (reps.length > 0) {
                reps.map(function (rep) {
                    let diff = moment().diff(moment(rep.datum), 'months')
                    dates.push(diff);
                })
                return Math.min(...dates) < months;
            }
            return false;
        },

        reportIstNeu(item, months) {
            let mdiff = moment().diff(moment(item.datum), 'months')
            return mdiff < months;
        },

        getDay(datum) {
            return moment(datum).format('DD')
        },
        getMonth(datum, length) {
            return length === 'long' ? moment(datum).format('MMM') : moment(datum).format('MM')
        },
        getYear(datum) {
            return moment(datum).format('YY')
        },
        arrayFromObject(obj) {
            var arr = [];
            for (var i in obj) {
                arr.push(obj[i]);
            }
            return arr;
        },
        groupBy(list, fn) {
            var groups = {};
            for (var i = 0; i < list.length; i++) {
                var group = JSON.stringify(fn(list[i]));
                if (group in groups) {
                    groups[group].push(list[i]);
                } else {
                    groups[group] = [list[i]];
                }
            }
            return this.arrayFromObject(groups);
        },
        biggerRightbox() {
            jQuery('#rightbox').css('height', 'auto')
            jQuery('.morebutton').fadeOut(100)

        },
        htmlEncode(value) {
            return jQuery('<div/>').html(value).text();
        }
    },
    directives: {
        adjustheight(el) {
            setTimeout(function () {
                let leftbox = jQuery('#leftbox').height()
                let rightbox = jQuery('#rightbox').height()
                if (rightbox - leftbox > 150) {
                    jQuery(el).css('height', leftbox)
                    jQuery('.morebutton').show();
                }
            }, 500)
        }
    }
}

export let connectionCheck = {

    data() {
        return {
            offline: false
        }
    },
    created() {
        window.addEventListener('online', this.networkChange)
        window.addEventListener('offline', this.networkChange)
    },
    methods: {
        networkChange(e) {
            this.offline = e.type == "offline";
        }
    }
}

export let resizeHandler = {
    data() {
        return {
            scrHeight: 0,
            windowWidth: 0
        }
    },
    methods: {
        getHeight: function () {
            this.scrHeight = window.innerHeight
            this.windowWidth = jQuery(window).width()
            // console.log(this.scrHeight)
        }
    },
    destroyed() {
        window.removeEventListener('resize', this.getHeight);
    },
    created: function () {
        this.getHeight()
        window.addEventListener('resize', this.getHeight, {passive: true})
    },

}

export let offset = {
    data: function () {
        return {
            offsetclass: false,
        }
    },
    updated: function () {

    },
    mounted: function () {
        this.offsetclass = false;
        this.$nextTick(function () {
            setTimeout(function () {
                this.offsetclass = true
            }.bind(this), 500)
        })
    },
}



// WEBPACK FOOTER //
// ./src/mixins/index.js